import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/sellers/seller1.png'
import _imports_1 from '@/assets/images/sellers/seller2.png'
import _imports_2 from '@/assets/images/sellers/seller3.png'
import _imports_3 from '@/assets/images/sellers/seller4.png'
import _imports_4 from '@/assets/images/sellers/seller5.png'
import _imports_5 from '@/assets/images/sellers/seller6.png'
import _imports_6 from '@/assets/images/sellers/seller7.png'
import _imports_7 from '@/assets/images/sellers/seller8.png'
import _imports_8 from '@/assets/images/sellers/seller9.png'
import _imports_9 from '@/assets/images/sellers/seller10.png'
import _imports_10 from '@/assets/images/sellers/seller11.png'
import _imports_11 from '@/assets/images/sellers/seller12.png'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle mt-[15px] sm:mt-0" }
const _hoisted_4 = { class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-[25px] mb-[25px]" }
const _hoisted_5 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_6 = { class: "trezo-card-content" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_10 = { class: "flex items-center gap-[9px]" }
const _hoisted_11 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_12 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_13 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_14 = { class: "trezo-card-content" }
const _hoisted_15 = { class: "flex items-center justify-between" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_18 = { class: "flex items-center gap-[9px]" }
const _hoisted_19 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_20 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_21 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_22 = { class: "trezo-card-content" }
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_26 = { class: "flex items-center gap-[9px]" }
const _hoisted_27 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_28 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_29 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_30 = { class: "trezo-card-content" }
const _hoisted_31 = { class: "flex items-center justify-between" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_34 = { class: "flex items-center gap-[9px]" }
const _hoisted_35 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_36 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_37 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_38 = { class: "trezo-card-content" }
const _hoisted_39 = { class: "flex items-center justify-between" }
const _hoisted_40 = { class: "flex items-center" }
const _hoisted_41 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_42 = { class: "flex items-center gap-[9px]" }
const _hoisted_43 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_44 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_45 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_46 = { class: "trezo-card-content" }
const _hoisted_47 = { class: "flex items-center justify-between" }
const _hoisted_48 = { class: "flex items-center" }
const _hoisted_49 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_50 = { class: "flex items-center gap-[9px]" }
const _hoisted_51 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_52 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_53 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_54 = { class: "trezo-card-content" }
const _hoisted_55 = { class: "flex items-center justify-between" }
const _hoisted_56 = { class: "flex items-center" }
const _hoisted_57 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_58 = { class: "flex items-center gap-[9px]" }
const _hoisted_59 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_60 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_61 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_62 = { class: "trezo-card-content" }
const _hoisted_63 = { class: "flex items-center justify-between" }
const _hoisted_64 = { class: "flex items-center" }
const _hoisted_65 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_66 = { class: "flex items-center gap-[9px]" }
const _hoisted_67 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_68 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_69 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_70 = { class: "trezo-card-content" }
const _hoisted_71 = { class: "flex items-center justify-between" }
const _hoisted_72 = { class: "flex items-center" }
const _hoisted_73 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_74 = { class: "flex items-center gap-[9px]" }
const _hoisted_75 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_76 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_77 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_78 = { class: "trezo-card-content" }
const _hoisted_79 = { class: "flex items-center justify-between" }
const _hoisted_80 = { class: "flex items-center" }
const _hoisted_81 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_82 = { class: "flex items-center gap-[9px]" }
const _hoisted_83 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_84 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_85 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_86 = { class: "trezo-card-content" }
const _hoisted_87 = { class: "flex items-center justify-between" }
const _hoisted_88 = { class: "flex items-center" }
const _hoisted_89 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_90 = { class: "flex items-center gap-[9px]" }
const _hoisted_91 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_92 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_93 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_94 = { class: "trezo-card-content" }
const _hoisted_95 = { class: "flex items-center justify-between" }
const _hoisted_96 = { class: "flex items-center" }
const _hoisted_97 = { class: "ltr:ml-[15px] rtl:mr-[15px]" }
const _hoisted_98 = { class: "flex items-center gap-[9px]" }
const _hoisted_99 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_100 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_101 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_102 = { class: "trezo-card-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"trezo-card-title\" data-v-17aed459><form class=\"relative sm:w-[265px]\" data-v-17aed459><label class=\"leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2\" data-v-17aed459><i class=\"material-symbols-outlined !text-[20px]\" data-v-17aed459> search </i></label><input type=\"text\" placeholder=\"Search seller here.....\" class=\"bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400\" data-v-17aed459></form></div>", 1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RouterLink, {
            to: "/ecommerce/create-seller",
            class: "inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white",
            id: "add-new-popup-toggle"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px]" }, [
                _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2" }, " add "),
                _createTextVNode(" Add New Seller ")
              ], -1)
            ])),
            _: 1,
            __: [0]
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                src: _imports_0,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Ava Turner ")
                  ])),
                  _: 1,
                  __: [2]
                }),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "block" }, " turner@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [5]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_11, _cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_12, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[8] || (_cache[8] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 25 Nov 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $9,999.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $5,999.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> TechMaster Store </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[11] || (_cache[11] = _createElementVNode("img", {
                src: _imports_1,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode(" Ethan Parker ")
                  ])),
                  _: 1,
                  __: [9]
                }),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "block" }, " ethan@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [12]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_19, _cache[13] || (_cache[13] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_20, _cache[14] || (_cache[14] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[15] || (_cache[15] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 01 Nov 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 39 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $6,756.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $4,645.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> RisionTech Outlet </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[18] || (_cache[18] = _createElementVNode("img", {
                src: _imports_2,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode(" Isabella Lee ")
                  ])),
                  _: 1,
                  __: [16]
                }),
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "block" }, " isabella@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [19]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_27, _cache[20] || (_cache[20] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_28, _cache[21] || (_cache[21] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[22] || (_cache[22] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 30 Sep 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 75 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $5,550.00 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $4,350.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> ComfotLiving </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[25] || (_cache[25] = _createElementVNode("img", {
                src: _imports_3,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode(" Thompson Torres ")
                  ])),
                  _: 1,
                  __: [23]
                }),
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "block" }, " thompson@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [26]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_35, _cache[27] || (_cache[27] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_36, _cache[28] || (_cache[28] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[29] || (_cache[29] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 02 Aug 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 99 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $2,100.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $1,500.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> SportFit Store </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _cache[32] || (_cache[32] = _createElementVNode("img", {
                src: _imports_4,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode(" Lucas Lyon ")
                  ])),
                  _: 1,
                  __: [30]
                }),
                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "block" }, " lucas@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[33] || (_cache[33] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [33]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_43, _cache[34] || (_cache[34] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_44, _cache[35] || (_cache[35] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[36] || (_cache[36] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 22 July 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 350 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $15,250.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $10,200.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> Velas Store </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _cache[39] || (_cache[39] = _createElementVNode("img", {
                src: _imports_5,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[37] || (_cache[37] = [
                    _createTextVNode(" Morgan Sturges ")
                  ])),
                  _: 1,
                  __: [37]
                }),
                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "block" }, " morgan@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[40] || (_cache[40] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [40]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_51, _cache[41] || (_cache[41] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_52, _cache[42] || (_cache[42] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[43] || (_cache[43] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 10 Jun 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 200 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $10,500.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $5,458.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> Herna Store </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _cache[46] || (_cache[46] = _createElementVNode("img", {
                src: _imports_6,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[44] || (_cache[44] = [
                    _createTextVNode(" Sophia McNeel ")
                  ])),
                  _: 1,
                  __: [44]
                }),
                _cache[45] || (_cache[45] = _createElementVNode("span", { class: "block" }, " sophia@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[47] || (_cache[47] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [47]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_59, _cache[48] || (_cache[48] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_60, _cache[49] || (_cache[49] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[50] || (_cache[50] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 16 Feb 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 80 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $2,580.00 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $1,500.00 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> Dona Store </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _cache[53] || (_cache[53] = _createElementVNode("img", {
                src: _imports_7,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_65, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[51] || (_cache[51] = [
                    _createTextVNode(" Rodriguez Meade ")
                  ])),
                  _: 1,
                  __: [51]
                }),
                _cache[52] || (_cache[52] = _createElementVNode("span", { class: "block" }, " rodriguez@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[54] || (_cache[54] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [54]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_67, _cache[55] || (_cache[55] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_68, _cache[56] || (_cache[56] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[57] || (_cache[57] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 12 May 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 150 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $9,000.00 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $6,000.00 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> Willi Dav Store </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _cache[60] || (_cache[60] = _createElementVNode("img", {
                src: _imports_8,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_73, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[58] || (_cache[58] = [
                    _createTextVNode(" Olivia Taylor ")
                  ])),
                  _: 1,
                  __: [58]
                }),
                _cache[59] || (_cache[59] = _createElementVNode("span", { class: "block" }, " olivia@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[61] || (_cache[61] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [61]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_75, _cache[62] || (_cache[62] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_76, _cache[63] || (_cache[63] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[64] || (_cache[64] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 10 Apr 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 75 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $7,500.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $4,500.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> Donne Store </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _cache[67] || (_cache[67] = _createElementVNode("img", {
                src: _imports_9,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[65] || (_cache[65] = [
                    _createTextVNode(" David Smith ")
                  ])),
                  _: 1,
                  __: [65]
                }),
                _cache[66] || (_cache[66] = _createElementVNode("span", { class: "block" }, " david@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_82, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[68] || (_cache[68] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [68]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_83, _cache[69] || (_cache[69] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_84, _cache[70] || (_cache[70] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[71] || (_cache[71] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 03 Dec 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 500 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $18,500.00 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $13,200.00 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> RichMaster Store </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_85, [
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _cache[74] || (_cache[74] = _createElementVNode("img", {
                src: _imports_10,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_89, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[72] || (_cache[72] = [
                    _createTextVNode(" Alice Johnson ")
                  ])),
                  _: 1,
                  __: [72]
                }),
                _cache[73] || (_cache[73] = _createElementVNode("span", { class: "block" }, " alice@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_90, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[75] || (_cache[75] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [75]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_91, _cache[76] || (_cache[76] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_92, _cache[77] || (_cache[77] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[78] || (_cache[78] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 23 Mar 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $6,300.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $4,000.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> Dajon Store </li></ul>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_93, [
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _cache[81] || (_cache[81] = _createElementVNode("img", {
                src: _imports_11,
                alt: "seller-image"
              }, null, -1)),
              _createElementVNode("div", _hoisted_97, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/seller-details",
                  class: "text-md inline-block mb-[2px] font-medium transition-all text-black dark:text-white hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[79] || (_cache[79] = [
                    _createTextVNode(" Emily Brown ")
                  ])),
                  _: 1,
                  __: [79]
                }),
                _cache[80] || (_cache[80] = _createElementVNode("span", { class: "block" }, " emily@clickai.live ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_98, [
              _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                to: "/ecommerce/seller-details",
                class: "text-primary-500 leading-none custom-tooltip"
              }, {
                default: _withCtx(() => _cache[82] || (_cache[82] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                ])),
                _: 1,
                __: [82]
              })), [
                [_directive_tooltip, 'View']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_99, _cache[83] || (_cache[83] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
              ]))), [
                [_directive_tooltip, 'Edit']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_100, _cache[84] || (_cache[84] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
              ]))), [
                [_directive_tooltip, 'Delete']
              ])
            ])
          ]),
          _cache[85] || (_cache[85] = _createStaticVNode("<ul class=\"mt-[20px]\" data-v-17aed459><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Last Sale Date: </span> 20 Jan 2024 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Item Stock: </span> 99 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Wallet Balance: </span> $3,699.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Revenue: </span> $2,599.50 </li><li class=\"text-black dark:text-white mb-[10px] last:mb-0\" data-v-17aed459><span class=\"text-gray-500 dark:text-gray-400\" data-v-17aed459> Store: </span> Barbahall Store </li></ul>", 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_101, [
      _createElementVNode("div", _hoisted_102, [
        _createVNode(_component_Pagination, {
          items: "12",
          total: "36",
          class: "pt-[0] md:pt-[0]"
        })
      ])
    ])
  ], 64))
}